var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"nopad":""}},[_c('a-field',{directives:[{name:"bullets",rawName:"v-bullets"}],attrs:{"config":_vm.config},model:{value:(_vm.notes),callback:function ($$v) {_vm.notes=$$v},expression:"notes"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }